import { dateTransform } from "helpers/dataHelpers";
import { TABLE_DATE } from "consts";
import { CancelIcon, CheckCircleIcon } from "icons";
import { theme } from "theme";
import { FlexContainer } from "styled/Box";

export const columns = [
  {
    title: "External service",
    dataIndex: "service",
    key: "service",
  },
  {
    title: "Operation",
    dataIndex: "operation",
    key: "operation",
  },
  {
    title: "Is blocking for order",
    dataIndex: "isBlockingForOrder",
    key: "isBlockingForOrder",
    algn: "center" as const,
    minWidth: 300,
    render: (value: boolean) => (
      <FlexContainer $minWidth={"150px"} $justify="center">
        {value ? (
          <CheckCircleIcon fill={theme.color.status.danger} />
        ) : (
          <CancelIcon fill={theme.color.status.success} />
        )}
      </FlexContainer>
    ),
  },
  {
    title: "Error type",
    dataIndex: "errorType",
    key: "errorType",
  },
  {
    title: "Order id",
    dataIndex: "orderId",
    key: "orderId",
  },
  {
    title: "Order sid",
    dataIndex: "orderSid",
    key: "orderSid",
  },
  {
    title: "Customer id",
    dataIndex: "customerId",
    key: "customerId",
  },
  {
    title: "Location id",
    dataIndex: "locationId",
    key: "locationId",
  },
  {
    title: "Human message",
    dataIndex: "humanMessage",
    key: "humanMessage",
    render: (value: string) => (
      <p style={{ minWidth: 300, whiteSpace: "pre-wrap" }}>{value}</p>
    ),
  },
  {
    title: "Created at",
    dataIndex: "timestamp",
    key: "timestamp",
    sorter: true,
    width: 180,
    render: (date: string) =>
      dateTransform({
        date,
        format: TABLE_DATE,
      }),
  },
];
